// Os balcões do caixa: contas abertas e balcões livres.
import React from "react";
import * as Styles from "../../styles/PointOfSale.styles";

export const TabelaDePedidosDeBalcao: React.FC<{
  component: any;
  componentProps: any;
  subsidiaryDataZustand: any;
  ordersTypeTable: string;
  setOrdersTypeTable: (tipo: string) => void;
  handleSearchByOrderTable: (orderUuid: any, order?: any, customer?: any) => void;
  getPeriodInfo: () => void;
}> = ({
  component,
  componentProps,
  subsidiaryDataZustand,
  ordersTypeTable,
  setOrdersTypeTable,
  handleSearchByOrderTable,
  getPeriodInfo,
}) => {

  let currentOrders: any[] =
    subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodOrders?.filter(
      (order: any) => order.orderType === 2
    ) ?? [];
  currentOrders.sort((a: any, b: any) => {
    const counterNameA =
      subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodCounters?.filter(
        (counter: any) =>
          counter.itemUuid ===
          a.orderInfo?.filter(
            (orderInfoValue: any) =>
              orderInfoValue.orderInfoType === 1
          )[0]?.orderInfoValue
      )[0]?.itemName;

    const counterNameB =
      subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodCounters?.filter(
        (counter: any) =>
          counter.itemUuid ===
          b.orderInfo?.filter(
            (orderInfoValue: any) =>
              orderInfoValue.orderInfoType === 1
          )[0]?.orderInfoValue
      )[0]?.itemName;

    // Compara os nomes dos balcões
    return counterNameA.localeCompare(counterNameB);
  });
  return (
    <Styles.CurrentOrdersTable
      selected={Boolean(component.componentSelected)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={String(componentProps.componentBrightness)}
      componentStatus={String(componentProps.componentStatus)}
      componentColor={String(componentProps.componentColor)}
      componentFontSize={String(componentProps.componentFontSize)}
      componentWidth={String(componentProps.componentWidth)}
      componentHeight={String(componentProps.componentHeight)}
      componentBackgroundColor={String(
        componentProps.componentBackgroundColor
      )}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      <span className="componentTitle">
        ATENDIMENTOS EM ANDAMENTO
      </span>

      <Styles.OrdersTypeButtons>
        <Styles.ShowOrdersTypeButton
          componentBackgroundColor="#1c50fe"
          onClick={() => {
            getPeriodInfo();
            setOrdersTypeTable("OpenPickupOrders");
          }}
        >
          {`Contas Abertas(${currentOrders?.filter(
            (order: any) => order.orderStatus < 6
          ).length
            })`}
        </Styles.ShowOrdersTypeButton>
      </Styles.OrdersTypeButtons>
      {ordersTypeTable === ordersTypeTable && (
        <Styles.OpenOrdersTable
          componentBrightness={"0.9"}
          componentStatus={String(componentProps.componentStatus)}
          componentBackgroundColor="transparent"
          componentColor={String(componentProps.componentColor)}
          componentHeight={String(componentProps.componentHeight)}
        >
          <Styles.OpenOrdersTableHeader
            componentColor={String(componentProps.componentColor)}
          >
            <Styles.OpenOrdersTableHeaderRow>
              <Styles.OpenOrdersTableHeaderCell columnWidth={"35%"}>
                Conta
              </Styles.OpenOrdersTableHeaderCell>
              <Styles.OpenOrdersTableHeaderCell columnWidth={"35%"}>
                Origem do Cliente
              </Styles.OpenOrdersTableHeaderCell>
              <Styles.OpenOrdersTableHeaderCell columnWidth={"30%"}>
                Status
              </Styles.OpenOrdersTableHeaderCell>
            </Styles.OpenOrdersTableHeaderRow>
          </Styles.OpenOrdersTableHeader>
          {currentOrders.map((order: any) => {
            const orderInfoValue = order.orderInfo?.map(
              (info: any) => {
                let parsedOrderInfoValue;
                try {
                  parsedOrderInfoValue = JSON.parse(
                    info.orderInfoValue
                  );
                } catch (error) {
                  parsedOrderInfoValue = null;
                }
                return {
                  ...info,
                  orderInfoValue:
                    parsedOrderInfoValue || info.orderInfoValue,
                };
              }
            );
            const counterName =
              subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodCounters?.filter(
                (desk: any) =>
                  desk.itemUuid ===
                  orderInfoValue?.filter(
                    (orderInfoValue: any) =>
                      orderInfoValue.orderInfoType === 1
                  )[0]?.orderInfoValue
              )[0]?.itemName;
            const origin = orderInfoValue?.filter(
              (orderInfoValue: any) =>
                orderInfoValue.orderInfoType === 5
            )[0]?.orderInfoValue;

            return order.orderStatus < 6 && order.orderType === 2 ? (
              <Styles.OpenOrdersTableRow
                key={order.orderUuid}
                onClick={() => {
                  handleSearchByOrderTable(order.orderUuid, order);
                  getPeriodInfo();
                }}
              >
                <Styles.OpenOrdersTableCell columnWidth={"35%"}>
                  {counterName}
                </Styles.OpenOrdersTableCell>
                <Styles.OpenOrdersTableCell columnWidth={"35%"}>
                  {origin === "directContact"
                    ? "Telefone"
                    : origin === "externalApp"
                      ? "Aplicativo Terceiro"
                      : origin === "internalApp"
                        ? "Alfredo"
                        : ""}
                </Styles.OpenOrdersTableCell>
                <Styles.OpenOrdersTableCell columnWidth={"30%"}>
                  {order.orderStatus === 0
                    ? "Recebido"
                    : order.orderStatus === 1
                      ? "Aberto"
                      : order.orderStatus === 2
                        ? "Em Produção"
                        : order.orderStatus === 3
                          ? "Bloqueada"
                          : order.orderStatus === 5
                            ? "Pagamento"
                            : ""}
                </Styles.OpenOrdersTableCell>
              </Styles.OpenOrdersTableRow>
            ) : null;
          })}
        </Styles.OpenOrdersTable>
      )}
    </Styles.CurrentOrdersTable>
  );
};
